// import signupTemplate from './signup/signup.pug';
import meTemplate from './me/me.pug';
import personalTemplate from './me/personal/personal.pug';
import contactTemplate from './me/contact/contact.pug';
import chnagePWTemplate from './me/changepassword/changepassword.pug';
import financialTemplate from './me/financial/financial.pug';

'use strict';

export default ['$stateProvider', function routes($stateProvider) {
  $stateProvider
  // .state('signup', {
  //   url: '/signup',
  //   template: signupTemplate,
  //   controller: 'SignupCtrl',
  //   controllerAs: 'vm'
  // })
    .state('me', {
      url: '/me',
      template: meTemplate,
      controller: 'MeViewCtrl',
      controllerAs: 'uservm',
      authenticate: true
    })
    .state('me.personal', {
      url: '/personal',
      template: personalTemplate,
      controller: 'MePersonalCtrl',
      controllerAs: 'vm',
      authenticate: true
    })
    .state('me.contact', {
      url: '/contact',
      template: contactTemplate,
      controller: 'MeContactCtrl',
      controllerAs: 'vm',
      authenticate: true
    })
    .state('me.changepassword', {
      url: '/changepassword',
      template: chnagePWTemplate,
      controller: 'MeChangePWCtrl',
      controllerAs: 'vm',
      authenticate: true
    })
    .state('me.financial', {
      url: '/financial',
      template: financialTemplate,
      controller: 'MeFinancialCtrl',
      controllerAs: 'vm',
      authenticate: true
    });
}];
